import React from 'react';
import {checkIsReadOnly, createSection, createSectionDefault} from "../schema"
import Tabcontents from './Tabcontents'
import RenderButton from './editorfields/Button'
import update from "immutability-helper/index";
import style from './addNewSectio.scss'
import {tabLabels, checkIsReadOnlySection} from "../schema"

// const tabs = {
//     general: {'label': "General"},
//     conditional: {'label': "Conditional Logic"}
// };

const sectionFields = createSection();
const sectionFieldsDefault = createSectionDefault();

// const Tabs = (props) => {
//     return (<ul>
//         {Object.keys(tabs).map(key => {
//             return <li key={key} onClick={() => {
//                 return props.switchTab(key)
//             }}>{tabs[key].label}</li>
//         })}
//
//     </ul>)
// };


class AddNewSection extends React.Component {


    switchTab = (tab) => {

        let {openTabs} = this.state;
        if (openTabs.indexOf(tab) === -1) {
            openTabs = [tab];
        } else {
            openTabs.splice(tab, 1);
        }
        this.setState((prevState) => ({
            ...prevState, openTabs
        }));

    }

    handleChange = (field, index) => {
        const {handleChange} = this.props;
        handleChange(field, index);
    }


    constructor(props) {
        super(props);
        this.state = {
            openTabs: ['general'],
        }
    }


    render() {
        const {section, closePopup, index} = this.props;
        const {openTabs} = this.state;

        let title = 'Add new section';

        if (section !== false) {
            title = `Edit ${  section.name}`;
        }
        return (
            <div className={style.popUpOuter}>
                <div className={style.mask}>Mask</div>
                <div className={style.addNewPopup}>
                    <div className={style.wrap}>
                        <span className={style.closePopup} role="button" tabIndex="0" onClick={closePopup}> X </span>
                        <h4 className={style.closeHead}>{title}</h4>
                    </div>
                    { /* console.log(sectionFieldsDefault) */ }
                    { /* console.log(section.key) */ }

                    { (section.key === 'billing' || section.key === 'shipping' || section.key === 'order' || section.key === 'account') ?

                    <Tabcontents
                        schema={sectionFieldsDefault}
                        field={section}
                        openTabs={openTabs}
                        switchTab={this.switchTab}
                        tabLabels={tabLabels}
                        checkIsReadOnly={checkIsReadOnlySection}
                        handleChange={(field) => {
                            return this.handleChange(field, index)
                        }}/>

                        :
                        <Tabcontents
                            schema={sectionFields}
                            field={section}
                            openTabs={openTabs}
                            switchTab={this.switchTab}
                            tabLabels={tabLabels}
                            checkIsReadOnly={checkIsReadOnlySection}
                            handleChange={(field) => {
                                return this.handleChange(field, index)
                            }}/>
                    }


                    { /*
                    <Tabcontents
                        schema={sectionFields}
                        field={section}
                        openTabs={openTabs}
                        switchTab={this.switchTab}
                        tabLabels={tabLabels}
                        checkIsReadOnly={checkIsReadOnlySection}
                        handleChange={(field) => {
                            return this.handleChange(field, index)
                        }}/>
                        */ }

                    <div className={style.wrap}>

                        <div className={style.buttonPopup + ' ' + style.buttonCancel}>
                            <RenderButton
                              item={{label: 'Cancel'}}
                              onClick={() => {
                                  closePopup();
                              }}
                            />
                        </div>

                        <div className={style.buttonPopup + ' ' + style.buttonDone}>
                            <RenderButton
                              item={{label: 'Done'}}
                              onClick={() => {
                                  const field = update(section, {"status": {$set: 1}});
                                  closePopup();
                                  return this.handleChange(field, index);
                              }}
                            />
                        </div>

                    </div>

                </div>
            </div>
        )
    }

}

export default AddNewSection;
